import React from 'react';
import { iconsList } from '../../../../../Icons';

const CheckedStep = () => {
  const { BsCheckCircle } = iconsList;
  return <BsCheckCircle className="text-xl mr-1.5" />;
};

export default CheckedStep;
